import Util from "./Util.js";
import { gsap } from "./Util.js";

class Page extends Util {
  constructor() {
    super();

    if (window.website.page === "top") {
      this.top();
      this.videoReplace();
    } else if (window.website.page === "online-store-expensive") {
      this.infoReplace();
    }
  }

  top() {
    gsap.fromTo(
      "#video-mv",
      {
        scale: 1.2,
      },
      {
        scale: 1.001,
        duration: 1.2,
        delay: 0.6,
        onUpdate: () => {},
      }
    );
    if (!window.website.isDesktop) {
      gsap.set("#mv .video-wrap", {
        height: window.innerHeight,
      });
    }
  }

  videoReplace() {
    const videos = document.querySelectorAll(".video-replace");
    if (window.website.isDesktop) {
      for (const video of videos) {
        let pcSrc = video.getAttribute("data-src-pc");
        video.setAttribute("src", pcSrc);

        video.pause();
        video.currentTime = 0;

        video.addEventListener("canplay", function () {
          video.muted = true;
          gsap.delayedCall(0.4, () => {
            video.play();
          });
        });
      }
    }
  }
  infoReplace() {
    const info = document.querySelector(".sticky-pc");
    if (info && window.website.isDesktop) {
      const infoDom = info;
      const infoContainer = document.querySelector(".info");
      if (infoContainer && infoDom) {
        infoContainer.appendChild(infoDom);
      }
    }
  }
}

export default Page;
